import React from 'react';
import Button from './components/Button';
import instance from './axios';
import setUiMessage from './Utilities/Tostify';
import { useDispatch } from 'react-redux';
import { logout, setAuthUser } from './redux/slices/auth/authSlice';

function MaintenancePageFallBack() {
  const dispatch = useDispatch();
  const handleRefresh = async () => {
    // This triggers a full browser reload
    // window.location.reload();
    try {
      const response = await instance.get('api/app/healthcheck');
      if (!response.data?.maintenance && response.data?.status) {
        sessionStorage.removeItem('maintenanceMode');
        window.location.reload();
        setUiMessage('suc', "We're back :)");
      }
      /*
        {
            status: true,
            message: "Server is up and running",
            maintenance: false
        }
    */
    } catch (error) {
      if (error?.response?.status === 503) {
        localStorage.clear();
        dispatch(logout());
        dispatch(setAuthUser(null));
        // navigate(`${DEFAULT_LOCAL_PATH}`);
        setUiMessage('err', "We're still under maintenance :(");
      }
    }
  };
  return (
    <div
      className="systemupgrade"
      style={{
        float: 'left',
        width: '100%',
        textAlign: 'center',
        backgroundColor: '#eff6ff',
        fontFamily: 'Arial',
        position: 'relative',
        top: '20px',
        fontWeight: 'normal',
        padding: '5rem',
        boxSizing: 'border-box',
        height: '90vh',
      }}
    >
      <h1 style={{ color: '#2c6f6b' }}>We’ll be back soon!</h1>

      <br />
      <br />

      <span>
        This application is temporarily unavailable due to scheduled system
        maintenance.
        <br />
        <br />
        Thank you for your cooperation.
      </span>
      <br />
      <br />
      <div>
        <Button
          text="See if we're back"
          variant="primary"
          onClick={handleRefresh}
        />
      </div>
    </div>
  );
}

export default MaintenancePageFallBack;
